import { useState } from "react";
import foto1 from "../../../assets/carrossel1.jpg";
import foto2 from "../../../assets/carrossel2.jpg";
import foto3 from "../../../assets/carrossel3.jpg";
import foto4 from "../../../assets/carrossel4.jpg";
import foto5 from "../../../assets/carrossel5.jpeg";
import foto6 from "../../../assets/carrossel6.jpeg";
import foto7 from "../../../assets/carrossel7.jpeg";
import foto8 from "../../../assets/carrossel8.jpeg";
import setaEsquerda from "../../../assets/seta_esquerda.png";
import setaDireita from "../../../assets/seta_direita.png";

const imagens = [foto1, foto2, foto3, foto4, foto5, foto6, foto7, foto8];

export default function Carrossel() {
  const [indexAtual, setIndexAtual] = useState(0);

  const voltarSlide = () => {
    setIndexAtual((prevIndex) =>
      prevIndex === 0 ? imagens.length - 1 : prevIndex - 1
    );
  };

  const avancarSlide = () => {
    setIndexAtual((prevIndex) =>
      prevIndex === imagens.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <section id="carrossel" className="carrossel-wrapper">
      <button className="seta esquerda" onClick={voltarSlide}>
        <img src={setaEsquerda} alt="Seta esquerda" />
      </button>

      <div className="carrossel-container">
        <img
          src={imagens[indexAtual]}
          alt="Slide atual"
          className="carrossel-img"
        />
      </div>

      <button className="seta direita" onClick={avancarSlide}>
        <img src={setaDireita} alt="Seta direita" />
      </button>
    </section>
  );
}
